export function formatIsoDate(isoString) {
  // Create a Date object from the ISO string
  const date = new Date(isoString);

  // Helper function to get the ordinal suffix (st, nd, rd, th)
  function getOrdinalSuffix(day) {
    // Special case for 11th, 12th, 13th
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  // Get the individual parts
  const day = date.getDate();
  const dayWithSuffix = day + getOrdinalSuffix(day);
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getFullYear();

  // Combine and return the formatted string
  return `${dayWithSuffix} of ${month} ${year}`;
}
